<template>
	<div v-if="bannerData" class="w-full gap-2 !py-2 bg-black flex-col md:flex-row flex justify-center items-center">
		<p class="!m-0 !p-0 w-fit text-xs/[18px] font-normal text-white text-center">
			{{ message }}
		</p>
		<hero-banner-modal
			ref="heroModal"
			v-if="hasModal && id === 'mothers_day'"
			:auto-show="autoShow"
			:id="id"
			btn-class="text-white text-xs/[18px] underline underline-offset-2"
			:show-btn="true"
			:btn-text="cta"
		>
			<template v-slot:content-left>
				<div class="flex flex-col gap-3 justify-center h-full max-h-[360px] !py-4.5">
					<h3 class="text-center !m-0 !p-0 font-butler-light text-2xl font-light uppercase">{{ title }}</h3>
					<p class="font-normal text-center text-sm !p-0 !m-0 !-mt-2">
						A curated selection of beauty essentials—soft, luminous, and timeless. The perfect gift, or a treat for
						yourself.
					</p>
					<p class="font-normal text-center text-sm !p-0 !m-0 !my-1">Available through May 11th at 11:59 PM MDT.</p>
					<a
						:href="route"
						aria-label="Learn more about our nonprofits link"
						class="text-sm text-white uppercase bg-black !py-3 !px-4 text-center"
					>
						Shop Cream + Sugar Collection
					</a>
				</div>
			</template>
			<template v-slot:content-right>
				<figure role="figure" :aria-label="title">
					<img :src="mothersDayModalImage" :alt="title" class="w-full object-cover max-h-[320px] md:max-h-[460px]" />
				</figure>
			</template>
		</hero-banner-modal>
		<hero-banner-modal
			ref="heroModal"
			v-else-if="hasModal && id === 'foster_care'"
			:auto-show="autoShow"
			:id="id"
			btn-class="text-white text-xs/[18px] underline underline-offset-2"
			:show-btn="true"
			:btn-text="cta"
		>
			<template v-slot:content-left>
				<div class="flex flex-col gap-3 justify-center h-full max-h-[360px] !py-4.5">
					<h3 class="text-center !m-0 !p-0 font-butler-light text-2xl font-light uppercase">{{ title }}</h3>
					<p class="font-normal text-center text-sm !p-0 !m-0 !-mt-2">
						Introducing St. Chalk Set and Ocean Breeze Towel – 100% of proceeds will be donated to Seint Foundations,
						where we are dedicated to helping foster families, children in care, and those who have aged out live their
						best lives.
					</p>
					<p class="font-normal text-center text-sm !p-0 !m-0 !my-1">
						Available through May 31st, 11:59PM, MDT, or while supplies last.
					</p>
					<a
						:href="foundationsEndpoint"
						aria-label="Seint Foundations"
						class="font-normal text-center underline text-sm !p-0 !m-0 !my-1"
					>
						Learn more about Seint Foundations
					</a>
					<a
						:href="route"
						aria-label="Learn more about our nonprofits link"
						class="text-sm text-white uppercase bg-black !py-3 !px-4 text-center"
					>
						Shop Foster Care Products
					</a>
				</div>
			</template>
			<template v-slot:content-right>
				<figure role="figure" :aria-label="title">
					<img :src="fosterModal" :alt="title" class="w-full object-cover max-h-[320px] md:max-h-[460px]" />
				</figure>
			</template>
		</hero-banner-modal>
		<hero-banner-modal
			ref="heroModal"
			v-else-if="hasModal && id === 'pp_one_b'"
			:auto-show="autoShow"
			:id="id"
			btn-class="text-white text-xs/[18px] underline underline-offset-2"
			:show-btn="true"
			:btn-text="cta"
		>
			<template v-slot:content-left>
				<div class="flex flex-col gap-3 justify-center h-full max-h-[360px] !py-4.5">
					<h3 class="text-center !m-0 !p-0 font-butler-light text-2xl font-light uppercase">{{ title }}</h3>
					<p class="font-normal text-sm !p-0 !m-0 !-mt-2 text-center">
						Get a <strong>FREE Lucky Pressed Pigment</strong> with any purchase thru March 18th at 9:59 AM MDT — happy
						shopping and happy Seint Paddy’s Day!
					</p>
					<a
						:href="route"
						aria-label="Learn more about our nonprofits link"
						class="text-sm text-white uppercase bg-black !py-3 !px-4 text-center"
					>
						Shop Now
					</a>
				</div>
			</template>
			<template v-slot:content-right>
				<figure role="figure" :aria-label="title">
					<img :src="ppModalImage" :alt="title" class="w-full object-cover max-h-[320px] md:max-h-[460px]" />
				</figure>
			</template>
		</hero-banner-modal>
		<hero-banner-modal
			ref="heroModal"
			v-else-if="hasModal && id === 'pp_two'"
			:auto-show="autoShow"
			:id="id"
			btn-class="text-white text-xs/[18px] underline underline-offset-2"
			:show-btn="true"
			:btn-text="cta"
		>
			<template v-slot:content-left>
				<div class="flex flex-col gap-3 justify-center h-full max-h-[360px] !py-4.5">
					<h3 class="text-center !m-0 !p-0 font-butler-light text-2xl font-light uppercase">{{ title }}</h3>
					<p class="font-normal text-sm !p-0 !m-0 !-mt-2 text-center">
						Get a <strong>FREE Lucky Pressed Pigment</strong> with the purchase of any three Pressed Pigments thru March
						31st at 11:59 PM MDT.
					</p>
					<a
						:href="route"
						aria-label="Learn more about our nonprofits link"
						class="text-sm text-white uppercase bg-black !py-3 !px-4 text-center"
					>
						Shop Pressed Pigments
					</a>
				</div>
			</template>
			<template v-slot:content-right>
				<figure role="figure" :aria-label="title">
					<img :src="ppModalImage" :alt="title" class="w-full object-cover max-h-[320px] md:max-h-[460px]" />
				</figure>
			</template>
		</hero-banner-modal>
		<a
			v-else-if="route"
			:href="route"
			class="inline-block text-white cursor-pointer underline text-xs/[18px]"
			:aria-label="cta"
		>
			{{ cta }}
		</a>
	</div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { useRewardsStore } from '@stores'

const props = defineProps({
	bannerData: {
		type: Object,
		default: null,
	},
	isCheckout: {
		type: Boolean,
		default: false,
	},
	foundationsEndpoint: {
		type: String,
		required: true,
	},
})

const rewardsStore = useRewardsStore()
const { getRewardById } = storeToRefs(rewardsStore)

const heroModal = ref(null)
const hasModal = ref(props.bannerData?.hasModal ?? false)
const id = ref(props.bannerData?.bannerId) // id that drives rewards config
const message = ref(props.bannerData?.message)
const cta = ref(props.bannerData?.cta_label)
const route = ref(props.bannerData?.cta_route)
const ppModalImage = ref('https://s3.us-east-2.amazonaws.com/seint.com/marketing-pages/landing/lucky-modal.jpg')
const mothersDayModalImage = ref(
	'https://s3.us-east-2.amazonaws.com/seint.com/marketing-pages/landing/cream-and-sugar-collection-modal.jpg'
)
const fosterModal = ref('https://s3.us-east-2.amazonaws.com/seint.com/marketing-pages/landing/foster-modal.jpg')

onMounted(async () => {
	const promises = [ppModalImage.value, mothersDayModalImage.value, fosterModal.value].map((url) => {
		return new Promise((resolve) => {
			const img = new Image()
			img.src = url
			img.onload = resolve
		})
	})

	await Promise.all(promises)
})

const reward = computed(() => getRewardById.value(id.value))
const autoShow = computed(() => {
	if (props.isCheckout) return false
	return props.bannerData?.autoShowModal || props.bannerData?.auto_show_info_modal
})
const title = computed(() => reward.value.modal_attributes.title)
// const description = ref(reward.value.modal_attributes.description) // not in use yet
</script>
